import { render, staticRenderFns } from "./coinLog.vue?vue&type=template&id=039cb58e&scoped=true&"
import script from "./coinLog.vue?vue&type=script&lang=js&"
export * from "./coinLog.vue?vue&type=script&lang=js&"
import style0 from "./coinLog.vue?vue&type=style&index=0&id=039cb58e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cb58e",
  null
  
)

export default component.exports